module.exports = __webpack_public_path__ + "static/media/guigo_partners.388763fa.svg";